const version='1.10.12'; const hash='568cb6f'; export {version, hash};
